import LoginOrRegist from "@/views/login/LoginOrRegist/LoginOrRegist.vue";
import Register from "@/views/login/Register/Register.vue";
import schoolSearch from "@/views/login/schoolSearch/schoolSearch.vue";
import LoginVerify from "@/views/login/loginVerify/loginVerify.vue";
import BindWechat from '@/views/login/bindWeChat/bindWechat.vue';
import findPassword from "@/views/login/findPassword/findPassword.vue";
import ClauseService from "@/views/login/clauseService/index.vue";

export default [
  {
    path: '/login',
    name: 'LoginOrRegist',
    component: LoginOrRegist,
  },
  {
    path: '/register',
    name: '注册',
    component: Register,
    meta: {
      keepAlive: true,
    }
  },
  {
    path: '/schoolSearch',
    name: '选择学校',
    component: schoolSearch,
  },{
    path: '/loginVerify',
    name: '验证',
    component: LoginVerify,
  },
  {
    path: '/bindWechat',
    name: '绑定微信',
    component: BindWechat,
  },
  {
    path: '/findPassword',
    name: '找回密码',
    component: findPassword,
  },
  {
    path: '/clauseService',
    name: '服务条款',
    component: ClauseService,
  }
]
